export const MFA_IDENTITY_TYPES = {
  EMAIL: 'email',
  PHONE: 'phone',
  GOOGLE_AUTHENTICATOR: 'googleauthenticator',
  GOOGLE_AUTHENTICATOR_UPPERCASE: 'GoogleAuthenticator',
} as const;

export type MFAIdentityType =
  (typeof MFA_IDENTITY_TYPES)[keyof typeof MFA_IDENTITY_TYPES];

export type MfaIdentity = {
  name: MFAIdentityType;
  isEnabled: boolean;
};

export type TwoFactorIdentity = {
  identityTypeName: MFAIdentityType;
  isEnabled: boolean;
};

export type TwoFA = {
  code: string;
  state: string;
  identityType: MFAIdentityType;
};

export type MfaRequiredResponseData = {
  identityTypes: Array<MfaIdentity>;
  state: string;
};

export type MfaConfirmationModalFormValues = {
  [key: string]: unknown;
  twoFA: TwoFA;
};

export type MfaErrorResponse = {
  code: string;
  message: string;
  data?: MfaRequiredResponseData;
};

export type TwoFactorRequestFn<
  TResponse = void,
  TBaseArgs extends object = Record<string, unknown>,
> = (
  args: TBaseArgs & { twoFA: TwoFA | null }
) => Promise<TResponse | MfaErrorResponse>;

export type TwoFactorActionOptions<
  TResponse,
  TBaseArgs extends object = Record<string, unknown>,
> = {
  requestFn: TwoFactorRequestFn<TResponse, TBaseArgs>;
  onBack: () => void;
  onSuccess: (response: TResponse) => void;
  onError: (error: MfaErrorResponse | Error | string) => void;
};

export type MfaMethodState = {
  resendUntil?: number;
  maskedContact?: string;
};

export type MfaStateData = Partial<Record<MFAIdentityType, MfaMethodState>>;
